export const AUTH_ERROR_STORAGE_KEY = 'authErrorCode'

export const isAuthErrorStatus = (statusCode) => ([401, 403, 500, 502]).indexOf(statusCode) > -1
export const isSuccessStatus = (statusCode) => ([200, 201, 304]).indexOf(statusCode) > -1

export const getAuthErrorCode = (statusCode) => {
    if (statusCode === 403) return 'ACCESS_DENIED'
    if (statusCode === 500 || statusCode === 502) return 'SERVER_UNAVAILABLE'
    return 'SESSION_EXPIRED'
}

export const handleAuthErrorAndRedirect = ({ statusCode, navigate, location }) => {
    if (!isAuthErrorStatus(statusCode)) return false

    const fromPath = location?.pathname || window.location.pathname || '/'
    const fromSearch = location?.search || window.location.search || ''
    localStorage.setItem(AUTH_ERROR_STORAGE_KEY, getAuthErrorCode(statusCode))
    navigate('/login', {state: { from: fromPath + fromSearch }})
    return true
}
